import { EXTERNAL_APP_URI } from '../../common/uri/property-uri.constants';
export interface IKanbanState {
    kanbanUrl?: string
}

export class KanbanState implements IKanbanState {
    kanbanUrl: string;

    constructor(options?: IKanbanState) {
        this.kanbanUrl = options?.kanbanUrl || EXTERNAL_APP_URI.KANBAN_APP
    }
}